<template>
  <div style="background-color: #eeeeee; padding-bottom: 100px">
    <img style="display: block; margin: 0 auto" src="../../assets/banner6.png" alt="" />
    <div class="main">
      <ul class="Breadcrumb">
        <li @click="backPage('/home')">首页</li>
        <li>></li>
        <!-- <li>服务支持</li>
        <li>></li> -->
        <li>在线课堂</li>
      </ul>
      <div class="content">
        <div class="menu">
          <Menu :active="'0'" />
        </div>
        <div class="apply">
          <div class="classRoom">
            <!-- <div v-if="technologyList.length>0" class="promotional">
                            <video ref="video" style="width:100%" muted="muted" class="video" :poster="technologyList[0].coverImage"
                                :src="technologyList[0].video" type="video/mp4" controls="controls">
                                <p>你的浏览器不支持video标签.</p>
                            </video>
                            <span>{{ technologyList[0].name }}</span>
                        </div> -->
            <div class="room_wrap" v-if="proList.length > 0">
              <p class="title">产品视频</p>
              <div
                @click="checkViedo(item.video)"
                :class="index % 2 ? '' : 'active'"
                v-for="(item, index) in proList"
                class="room_video"
              >
                <p class="name">{{ item.name }}</p>
                <div>
                  <img :src="item.coverImage" alt="" />
                  <div class="description" v-html="item.description"></div>
                </div>
              </div>
              <pagination
                :num="proTotal"
                :limit="pageSize"
                @getNew="getList1"
              ></pagination>
            </div>
            <!-- <div class="room_wrap" v-if="tecList.length>0">
                            <p class="title">技术视频</p>
                            <div @click="checkViedo(item.video)" :class="index % 2 ? '' : 'active'" v-for="(item, index) in tecList" class="room_video">
                                <p class="name">{{ item.name }}</p>
                                <div>
                                    <img :src="item.coverImage" alt="">
                                    <div class="description" v-html="item.description"></div>
                                </div>
                            </div>
                            <pagination :num="tecTotal" :limit="3" @getNew="getList"></pagination>
                        </div> -->
          </div>
        </div>
        <video-box class="videobox" v-show="showVideo" :videoUrl="videoUrl"></video-box>
      </div>
    </div>
  </div>
</template>
<script>
import Menu from "./menu/index.vue";
import { getVideoList } from "../../api/index";
import videoBox from "./video.vue";
import pagination from "../../components/page/pagination.vue";
export default {
  components: {
    Menu,
    videoBox,
    pagination,
  },
  data() {
    return {
      technologyList: [],
      showVideo: false,
      videoUrl: "",
      tecList: [],
      tecNum: 1,
      tecTotal: 0,
      proList: [],
      proNum: 1,
      proTotal: 0,
      pageSize: 3,
    };
  },
  methods: {
    getList(val) {
      let params = {
        category: "2",
        promotional: "0",
        pageSize: this.pageSize,
        pageNum: val + 1,
      };
      getVideoList(params).then((res) => {
        this.tecList = res.rows;
        this.tecTotal = res.total;
      });
    },
    getList1(val) {
      let params = {
        category: "1",
        promotional: "0",
        pageSize: this.pageSize,
        pageNum: val + 1,
      };
      getVideoList(params).then((res) => {
        this.proList = res.rows;
        this.proTotal = res.total;
      });
    },
    checkViedo(url) {
      this.showVideo = true;
      this.videoUrl = url;
    },
    getLocalizedPath(rawPath) {
      const currentLang = this.$i18nState.locale || "zh";
      // 如果路径已经以 /zh 或 /en 结尾，则直接返回
      if (/\/(zh|en)$/.test(rawPath)) {
        return rawPath;
      }
      // 移除路径末尾多余的斜杠，然后添加语言
      const base = rawPath.endsWith("/") ? rawPath.slice(0, -1) : rawPath;
      return `${base}/${currentLang}`;
    },
    backPage(page) {
      const fullPath = this.getLocalizedPath(page);
      this.$router.replace({ path: fullPath });
    },
  },
  mounted() {
    getVideoList({ promotional: "1" }).then((res) => {
      this.technologyList = res.rows;
    });
    this.getList(0);
    this.getList1(0);
  },
};
</script>
<style lang="scss" scoped>
.content {
  display: flex;
  position: relative;

  .menu {
    width: 250px;
  }

  .apply {
    flex: 1;
    margin-left: 30px;
  }

  .videobox {
    position: fixed;
    top: 200px;
    left: 20%;
    width: 60%;
    height: 700px;
  }
}

.promotional {
  position: relative;
  cursor: pointer;

  span {
    position: absolute;
    bottom: 0;
    left: 0;
    display: block;
    width: 100%;
    height: 50px;
    color: #fff;
    background-color: rgba($color: #476da7, $alpha: 0.2);
    line-height: 50px;
    text-align: center;
    font-size: 18px;
  }

  img {
    height: 100%;
  }
}

.room_wrap {
  background-color: #fff;
  margin-top: 30px;
  padding: 20px 0;
  border: 1px solid #c7c7c7;
  box-sizing: border-box;
  > div {
    cursor: pointer;
  }
  .title {
    font-size: 22px;
    text-indent: 20px;
    margin-bottom: 14px;
    color: #414141;
  }

  .room_video {
    padding: 20px 24px;

    > div {
      overflow: hidden;
      display: flex;
    }
  }

  .room_video.active {
    background-color: #f5f5f5;
  }

  .name {
    font-size: 18px;
    margin-bottom: 14px;
    color: #000000;
  }

  img {
    width: 286px;
    height: 140px;
    float: left;
  }
}
.description {
  flex: 1;
  // padding: 40px 20px;
  // height: 60px;
  line-height: 26px;
  padding-left: 10px;
  font-size: 16px;
  p {
    color: #000000;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/fwzc/onlineClass.vue